import { Form, Input } from 'decorator-form';
import InputType from 'common/form/InputType';
import SubFormWidget from 'common/form/widgets/SubFormWidget';

@Form({title: "InputGroup Styles"})
export class InputGroupStylesConfig {
	
	@Input({type: InputType.TEXT, title: "Default Value"})
	public defaultValue: string="";

	@Input({type: InputType.CHECKBOX, title: "Disabled"})
	public disabled: boolean = false;

	@Input({type: InputType.CHECKBOX, title: "Fill"})
	public fill: boolean = false;

	@Input({type: InputType.CHECKBOX, title: "Large"})
	public large: boolean = false;

	@Input({type: InputType.CHECKBOX, title: "Round"})
	public round: boolean = false;

	
	@Input({type: InputType.CHECKBOX, title: "small"})
	public small: boolean = false;

	@Input({type: InputType.TEXT, title: "Type"})
	public type: string="text";

}

export const InputGroupStylesInput = SubFormWidget.registerForm(InputGroupStylesConfig);

@Form({title: "Input View Config"})
export default class InputConfig {

	@Input({type: InputType.TEXT, title: "Transition"})
	public transition: string = "0.2s ease-in-out";

	@Input({type: InputGroupStylesInput, title: "InputGroup Styles"})
	public inputGroupState: InputGroupStylesConfig;

	@Input({type: InputType.TEXTAREA, title: "CSS Styles"})
	public cssStyled: string;

}



// WEBPACK FOOTER //
// ./src/common/views/input/InputConfig.ts